import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Globe } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="bg-[#0A0A0A] border-t border-[#D4AF37]/20"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-6">
            <div className="flex flex-col leading-none">
              <span className="text-xs tracking-[0.3em] text-[#D4AF37]">• SREG •</span>
              <span className="text-[11px] tracking-[0.12em] text-zinc-300 uppercase">The Shalabi Real Estate Group</span>
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Real Estate. No Bullshit. Just Results. Serving Southern
              California since 2011.
            </p>
            <div className="flex items-center gap-3">
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/RE-MAX_logo.png/320px-RE-MAX_logo.png" 
                alt="RE/MAX" 
                className="h-8 object-contain"
              />
              <span className="text-zinc-500 text-sm">RE/MAX TIME</span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-6">
            <h4 className="text-sm font-bold uppercase tracking-widest text-white">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-3">
              <Link
                to="/buy"
                className="text-zinc-400 hover:text-[#D4AF37] transition-colors text-sm"
                data-testid="footer-link-buy"
              >
                Buy With Me
              </Link>
              <Link
                to="/sell"
                className="text-zinc-400 hover:text-[#D4AF37] transition-colors text-sm"
                data-testid="footer-link-sell"
              >
                Sell With Me
              </Link>
              <Link
                to="/testimonials"
                className="text-zinc-400 hover:text-[#D4AF37] transition-colors text-sm"
                data-testid="footer-link-testimonials"
              >
                Testimonials
              </Link>
              <Link
                to="/resources"
                className="text-zinc-400 hover:text-[#D4AF37] transition-colors text-sm"
                data-testid="footer-link-resources"
              >
                Resources
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="space-y-6">
            <h4 className="text-sm font-bold uppercase tracking-widest text-white">
              Contact
            </h4>
            <div className="space-y-4">
              <a
                href="tel:+19092335411"
                className="flex items-center gap-3 text-zinc-400 hover:text-[#D4AF37] transition-colors text-sm"
                data-testid="footer-phone"
              >
                <Phone className="w-4 h-4 text-[#D4AF37]" />
                909.233.5411
              </a>
              <a
                href="mailto:raadshalabi41@gmail.com"
                className="flex items-center gap-3 text-zinc-400 hover:text-[#D4AF37] transition-colors text-sm"
                data-testid="footer-email"
              >
                <Mail className="w-4 h-4 text-[#D4AF37]" />
                Raadshalabi41@gmail.com
              </a>
              <div className="flex items-start gap-3 text-zinc-400 text-sm">
                <MapPin className="w-4 h-4 text-[#D4AF37] mt-0.5" />
                <div className="leading-relaxed">
                  <p>10535 E Foothill Blvd #460</p>
                  <p>Rancho Cucamonga, CA 91730</p>
                </div>
              </div>
              <a
                href="https://theshalabigroup.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-zinc-400 hover:text-[#D4AF37] transition-colors text-sm"
                data-testid="footer-website"
              >
                <Globe className="w-4 h-4 text-[#D4AF37]" />
                theshalabigroup.com
              </a>
            </div>
          </div>

          {/* Hours */}
          <div className="space-y-6">
            <h4 className="text-sm font-bold uppercase tracking-widest text-white">
              Available
            </h4>
            <p className="text-zinc-400 text-sm leading-relaxed">
              I actually answer my phone. Call me anytime - if I miss you, I'll
              call back.
            </p>
            <p className="text-[#D4AF37] text-sm font-semibold">
              7 Days a Week
            </p>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-[#D4AF37]/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-500 text-sm">
            &copy; {new Date().getFullYear()} The Shalabi Real Estate Group. All
            rights reserved.
          </p>
          <p className="text-zinc-400 text-xs">
            DRE #01905641 | RE/MAX TIME
          </p>
        </div>
      </div>
    </footer>
  );
}
